// import * as React from 'react';
// import { styled } from '@mui/material/styles';
// import Switch from '@mui/material/Switch';

// // Customized iOS-style MUI switch
// const IOSSwitch = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 45,      // ← made it wider
//   height: 20,     // ← made it shorter
//   padding: 0,
//   '& .MuiSwitch-switchBase': {
//     padding: 0,
//     margin: 2,    // ← small margin to center thumb
//     transitionDuration: '300ms',
//     '&.Mui-checked': {
//       transform: 'translateX(30px)', // ← width-thumb-2*margin (52−18−4)
//       color: '#fff',
//       '& + .MuiSwitch-track': {
//         backgroundColor: '#65C466',
//         opacity: 1,
//         border: 0,
//       },
//     },
//     '&.Mui-focusVisible .MuiSwitch-thumb': {
//       color: '#65C466',
//       border: '6px solid #fff',
//     },
//   },
//   '& .MuiSwitch-thumb': {
//     boxSizing: 'border-box',
//     width: 12,    // ← smaller thumb
//     height: 12,   // ← smaller thumb
//   },
//   '& .MuiSwitch-track': {
//     borderRadius: 20 / 2, 
//     backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
//     opacity: 1,
//     transition: theme.transitions.create(['background-color'], {
//       duration: 500,
//     }),
//   },
// }));

// export default IOSSwitch;



import * as React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

// 45×20 iOS-style switch
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => {
  const TRACK_WIDTH = 40;
  const TRACK_HEIGHT = 20;
  const THUMB_SIZE = 16;
  const MARGIN = (TRACK_HEIGHT - THUMB_SIZE) / 2; // =2
  const TRANSFORM_X = TRACK_WIDTH - THUMB_SIZE - 2 * MARGIN; // =45 -16 -4 =25

  return ({
    width: TRACK_WIDTH,
    height: TRACK_HEIGHT,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: MARGIN,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: `translateX(${TRANSFORM_X}px)`,
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#1F9619',
          opacity: 1,
          border: 0,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#1F9619',
        border: '6px solid #fff',
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: THUMB_SIZE,
      height: THUMB_SIZE,
    },
    '& .MuiSwitch-track': {
      borderRadius: TRACK_HEIGHT / 2,
      // backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      backgroundColor: theme.palette.mode === 'light' ? '#b3b3b3' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  });
});

export default IOSSwitch;
